export const actionTypes = {
  MODIFY_DELEGATIONS: "MODIFY_DELEGATIONS",
  MODIFY_SELECTED_ROLE: "MODIFY_SELECTED_ROLE",
  MODIFY_SELECTED_USERS_DELEGATION: "MODIFY_SELECTED_USERS_DELEGATION",
  DELEGATION_REQUEST: "DELEGATION_REQUEST",
  DELEGATION_REQUEST_SUCCESS: "DELEGATION_REQUEST_SUCCESS",
  DELEGATION_REQUEST_FAILURE: "DELEGATION_REQUEST_FAILURE",
  DELETE_DELEGATION_REQUEST: "DELETE_DELEGATION_REQUEST",
  DELETE_DELEGATION_REQUEST_SUCCESS: "DELETE_DELEGATION_REQUEST_SUCCESS",
  DELETE_DELEGATION_REQUEST_FAILURE: "DELETE_DELEGATION_REQUEST_FAILURE",
  MODIFY_DELEGATION_REQUEST: "MODIFY_DELEGATION_REQUEST",
  MODIFY_DELEGATION_REQUEST_SUCCESS: "MODIFY_DELEGATION_REQUEST_SUCCESS",
  MODIFY_DELEGATION_REQUEST_FAILURE: "MODIFY_DELEGATION_REQUEST_FAILURE",
  DELEGATION_USER_REQUEST: "DELEGATION_USER_REQUEST",
  DELEGATION_USER_REQUEST_SUCCESS: "DELEGATION_USER_REQUEST_SUCCESS",
  DELEGATION_USER_REQUEST_FAILURE: "DELEGATION_USER_REQUEST_FAILURE",
  DELEGATION_USER_BAO_REQUEST: "DELEGATION_USER_BAO_REQUEST",
  DELEGATION_USER_BAO_REQUEST_SUCCESS: "DELEGATION_USER_BAO_REQUEST_SUCCESS",
  DELEGATION_USER_BAO_REQUEST_FAILURE: "DELEGATION_USER_BAO_REQUEST_FAILURE",
  CREATE_DELEGATION: "CREATE_DELEGATION",
  CREATE_DELEGATION_SUCCESS: "CREATE_DELEGATION_SUCCESS",
  CREATE_DELEGATION_FAILURE: "CREATE_DELEGATION_FAILURE",
  RESET_DELEGATION_STATE: "RESET_DELEGATION_STATE",
  RESET_CALL_STATE: "RESET_CALL_STATE",
};

export const modifyDelegations = (delegations: any[]) => ({
  type: actionTypes.MODIFY_DELEGATIONS,
  delegations,
});

export const modifySelectedRole = (selectedRole: {}) => ({
  type: actionTypes.MODIFY_SELECTED_ROLE,
  selectedRole,
});

export const modifySelectedUsersDelegation = (selectedUsers: any[]) => ({
  type: actionTypes.MODIFY_SELECTED_USERS_DELEGATION,
  selectedUsers,
});

export const delegationRequest = () => ({
  type: actionTypes.DELEGATION_REQUEST,
});

export const delegationRequestSuccess = (payload: any) => ({
  type: actionTypes.DELEGATION_REQUEST_SUCCESS,
  payload,
});

export const delegationRequestFailure = (err: any) => ({
  type: actionTypes.DELEGATION_REQUEST_FAILURE,
  err,
});

export const deleteDelegationRequest = (id: string) => ({
  type: actionTypes.DELETE_DELEGATION_REQUEST,
  id,
});

export const deleteDelegationRequestSuccess = (payload: any) => ({
  type: actionTypes.DELETE_DELEGATION_REQUEST_SUCCESS,
  payload,
});

export const deleteDelegationRequestFailure = (err: any) => ({
  type: actionTypes.DELETE_DELEGATION_REQUEST_FAILURE,
  err,
});

export const modifyDelegationRequest = (id: string, modifyDate: {}) => ({
  type: actionTypes.MODIFY_DELEGATION_REQUEST,
  id,
  modifyDate,
});

export const modifyDelegationRequestSuccess = (payload: any) => ({
  type: actionTypes.MODIFY_DELEGATION_REQUEST_SUCCESS,
  payload,
});

export const modifyDelegationRequestFailure = (err: any) => ({
  type: actionTypes.MODIFY_DELEGATION_REQUEST_FAILURE,
  err,
});

export const delegationUserRequest = () => ({
  type: actionTypes.DELEGATION_USER_REQUEST,
});

export const delegationUserRequestSuccess = (payload: any) => ({
  type: actionTypes.DELEGATION_USER_REQUEST_SUCCESS,
  payload,
});

export const delegationUserRequestFailure = (err: any) => ({
  type: actionTypes.DELEGATION_USER_REQUEST_FAILURE,
  err,
});

export const delegationUserBAORequest = (ou: string) => ({
  type: actionTypes.DELEGATION_USER_BAO_REQUEST,
  ou,
});

export const delegationUserBAORequestSuccess = (payload: any) => ({
  type: actionTypes.DELEGATION_USER_BAO_REQUEST_SUCCESS,
  payload,
});

export const delegationUserBAORequestFailure = (err: any) => ({
  type: actionTypes.DELEGATION_USER_BAO_REQUEST_FAILURE,
  err,
});

export const createDelegationRequest = (delegationOBJ: {}) => ({
  type: actionTypes.CREATE_DELEGATION,
  delegationOBJ,
});

export const createDelegationRequestSuccess = (payload: any) => ({
  type: actionTypes.CREATE_DELEGATION_SUCCESS,
  payload,
});

export const createDelegationRequestFailure = (err: any) => ({
  type: actionTypes.CREATE_DELEGATION_FAILURE,
  err,
});

export const resetDelegationState = () => ({
  type: actionTypes.RESET_DELEGATION_STATE,
});

export const resetCallState = () => ({
  type: actionTypes.RESET_CALL_STATE,
});
